export function getIndex(arr: any[] | undefined, property: string) {
  const index = arr
    ? ((arr?.findIndex(p => p.key === property) as unknown) as number)
    : 0;
  return index;
}
